export default function localeLang() {
    let _hostname = window.location.hostname;
    if(_hostname.indexOf('en') > -1){
        return 'en';
    }
    if(_hostname.indexOf('kr') > -1){
        return 'kr';
    }
    if(_hostname.indexOf('th') > -1){
        return 'th';
    }
    if(_hostname.indexOf('vn') > -1){
        return 'vn';
    }
    return 'vn';
}


// WEBPACK FOOTER //
// ./src/utils/localeLang.js